import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { FormFieldset } from '@tesla/design-system-react';

var _excluded = ["children"];
function FormGroup(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(FormFieldset, _extends({}, props, {
    legend: props.label
  }), children);
}

export { FormGroup };
